module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-641f582a.png";